import React, { useCallback, useEffect, useState } from 'react';
import { Card, Tag, Button, Typography, Empty, Row, Col, Space } from 'antd';
import { PlusOutlined, FileTextOutlined, ArrowRightOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import api from '../../../../services/api';
import dayjs from 'dayjs';

const { Text } = Typography;
const PRIMARY = '#128C7E';
const fmtBRL = (v) => `R$ ${Number(v || 0).toFixed(2).replace('.', ',')}`;

const STATUS_META = {
  sent: { color: 'green', label: 'Enviado' },
  scheduled: { color: 'blue', label: 'Agendado' },
  sending: { color: 'processing', label: 'Enviando' },
  partial_error: { color: 'orange', label: 'Parcial' },
  error: { color: 'red', label: 'Erro' },
};

export default function RecentBatchesCard({ communityTeamId }) {
  const nav = useNavigate();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    if (!communityTeamId) return;
    setLoading(true);
    try {
      const r = await api.get('/community/finance/charges/batches', { params: { team_id: communityTeamId, page: 1, limit: 5 } });
      setItems(r.data.items || []);
    } catch { /* silent */ }
    finally { setLoading(false); }
  }, [communityTeamId]);
  useEffect(() => { load(); }, [load]);

  return (
    <Card
      title={<Space><FileTextOutlined /><Text strong>Últimas cobranças</Text></Space>}
      styles={{ header: { padding: '12px 16px' }, body: { padding: items.length === 0 ? 24 : 12 } }}
      extra={
        <Space wrap size={8}>
          {items.length > 0 && (
            <Button type="link" size="small" onClick={() => nav('/comunidade/financeiro/cobrancas')}>
              Ver todas <ArrowRightOutlined />
            </Button>
          )}
          <Button type="primary" icon={<PlusOutlined />}
            style={{ background: PRIMARY, borderColor: PRIMARY }}
            onClick={() => nav('/comunidade/financeiro/nova-cobranca')}>
            Nova cobrança
          </Button>
        </Space>
      }
    >
      {loading ? (
        <div style={{ textAlign: 'center', padding: 24 }}><Text type="secondary">Carregando…</Text></div>
      ) : items.length === 0 ? (
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description={
            <div>
              <Text strong>Nenhuma cobrança ainda</Text>
              <br />
              <Text type="secondary" style={{ fontSize: 12 }}>Cria a primeira pra começar a cobrar seus jogadores.</Text>
            </div>
          }
        >
          <Button type="primary" icon={<PlusOutlined />}
            style={{ background: PRIMARY, borderColor: PRIMARY }}
            onClick={() => nav('/comunidade/financeiro/nova-cobranca')}>
            Nova cobrança
          </Button>
        </Empty>
      ) : (
        <Space direction="vertical" style={{ width: '100%' }} size={8}>
          {items.map(b => {
            const paidCount = Number(b.paid_count || 0);
            const total = Number(b.total_recipients || 0);
            const pct = total > 0 ? Math.round((paidCount / total) * 100) : 0;
            const status = STATUS_META[b.status] || { color: 'default', label: b.status };
            return (
              <div key={b.id}
                onClick={() => nav(`/comunidade/financeiro/lote/${b.id}`)}
                style={{
                  padding: 12,
                  borderRadius: 8,
                  border: '1px solid #f0f0f0',
                  cursor: 'pointer',
                  transition: 'all 0.15s',
                  background: '#fff',
                }}
                onMouseEnter={e => { e.currentTarget.style.borderColor = PRIMARY; e.currentTarget.style.background = '#f0faf7'; }}
                onMouseLeave={e => { e.currentTarget.style.borderColor = '#f0f0f0'; e.currentTarget.style.background = '#fff'; }}
              >
                <Row justify="space-between" align="top" wrap gutter={[8, 4]}>
                  <Col flex="1" style={{ minWidth: 0 }}>
                    <Text strong style={{ fontSize: 14, display: 'block', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{b.name}</Text>
                    <Text type="secondary" style={{ fontSize: 11 }}>{dayjs(b.created_at).format('DD/MM/YYYY HH:mm')}</Text>
                  </Col>
                  <Col>
                    <Tag color={status.color} style={{ margin: 0 }}>{status.label}</Tag>
                  </Col>
                </Row>
                <div style={{ marginTop: 6, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <Text type="secondary" style={{ fontSize: 12 }}>
                    <Text strong style={{ color: PRIMARY, fontSize: 12 }}>{paidCount}/{total}</Text> pagas · {pct}%
                  </Text>
                  <Text strong style={{ fontSize: 12, color: PRIMARY }}>
                    {fmtBRL(b.paid_amount_brl || 0)} <Text type="secondary" style={{ fontSize: 11 }}>/ {fmtBRL(b.total_amount_brl)}</Text>
                  </Text>
                </div>
              </div>
            );
          })}
        </Space>
      )}
    </Card>
  );
}
